(() => {
  if (customElements.get('gift-card-denomination-picker')) return;

  class GiftCardDenominationPicker extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.customTrigger = this.querySelector('[data-pkm-gift-card-custom-trigger]');
      this.customMenu = this.querySelector('[data-pkm-gift-card-custom-menu]');
      this.customCurrent = this.querySelector('[data-pkm-gift-card-custom-current]');
      this.customOptions = Array.from(this.querySelectorAll('[data-pkm-gift-card-option]'));
      this.radios = Array.from(this.querySelectorAll('[data-pkm-gift-card-denomination]'));

      if (!this.customTrigger || !this.customMenu || !this.customCurrent || this.radios.length === 0) return;

      this.customTrigger.addEventListener('click', () => this.toggleMenu(this.customMenu.hidden), { signal });
      this.customOptions.forEach((option) => {
        option.addEventListener('click', () => this.selectOption(option), { signal });
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-pkm-gift-card-denomination]')) this.syncFromSelection(event.target);
      }, { signal });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.toggleMenu(false);
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || this.customMenu.hidden) return;
        event.preventDefault();
        this.toggleMenu(false);
        this.customTrigger.focus();
      }, { signal });

      this.syncFromSelection(this.radios.find((radio) => radio.checked));
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    toggleMenu(open) {
      this.customMenu.hidden = !open;
      this.customTrigger.setAttribute('aria-expanded', String(open));
      if (open) {
        const selected = this.customOptions.find((option) => option.getAttribute('aria-selected') === 'true');
        (selected || this.customOptions.find((option) => !option.disabled))?.focus();
      }
    }

    selectOption(option) {
      const radio = this.querySelector(`#${CSS.escape(option.dataset.inputId || '')}`);
      if (!radio || radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      this.toggleMenu(false);
      this.customTrigger.focus();
    }

    syncFromSelection(radio) {
      if (!radio) return;
      const isCustom = !radio.hasAttribute('data-pkm-gift-card-quick');
      this.toggleAttribute('data-custom-active', isCustom);
      this.customTrigger.toggleAttribute('data-selected', isCustom);
      this.customCurrent.textContent = isCustom
        ? radio.dataset.pkmGiftCardLabel
        : this.customCurrent.dataset.defaultLabel;
      this.customOptions.forEach((option) => {
        option.setAttribute('aria-selected', String(option.dataset.inputId === radio.id));
      });
    }
  }

  customElements.define('gift-card-denomination-picker', GiftCardDenominationPicker);
})();
